<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('evento') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'events' })">{{
                                        $t('eventos')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        !eventoDados.idtipoevento
                                            ? $t('novo-evento')
                                            : eventoDados.descricao
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'evento-list',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-5">
                            <v-input
                                :id="'codigo'"
                                ref="idtipoeventoerpInput"
                                v-model="eventoDados.idtipoeventoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-7">
                            <v-input
                                v-model="eventoDados.descricao"
                                :id="'descricao-evento'"
                                :placeholder="'descricao-do-evento-placeholder'"
                                :maxlength="30"
                                :title="'descricao-evento'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!eventoDados.descricao"
                                ref="descricaoInput"
                                :required="true"
                            />
                        </div>
                        <div class="column is-5">
                            <label v-text="$t('obriga-form-evento')" />
                            <v-select
                                class="obriga"
                                :selectOnTab="true"
                                ref="obrigaInput"
                                :options="tfs"
                                :value="tf"
                                @input="updateObrigaEvento"
                                placeholder="sim"
                                :clearable="false"
                            >
                                <template slot="no-options">
                                    {{ $t('sem-resultados-filtro') }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                        <div class="column is-4">
                            <label>{{ $t('inicio-fim') }}</label
                            ><br />
                            <b-switch
                                v-model="initend"
                                :title="initend ? $t('ativado') : $t('desativado')"
                            >
                                <span v-if="initend">{{ $t('ativado') }}</span>
                                <span v-else>{{ $t('desativado') }}</span>
                            </b-switch>
                        </div>
                    </div>
                </div>
                <div class="columns is-flex-wrap mt-2" v-if="!initend">
                    <div class="column is-6">
                        <div class="box">
                            <p v-text="$t('geral')" class="mb-2" />
                            <div class="options">
                                <div class="columns is-flex-wrap">
                                    <div class="column is-6">
                                        <label>{{ $t('campo-obrigatorio') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoG.obriga"
                                            :title="
                                                eventoG.obriga ? $t('ativado') : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoG.obriga">{{ $t('ativado') }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('respeita-ordem') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoG.respeitaordem"
                                            :title="
                                                eventoG.respeitaordem
                                                    ? $t('ativado')
                                                    : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoG.respeitaordem">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('preenche-manual') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoG.preenchemanual"
                                            :title="
                                                eventoG.preenchemanual
                                                    ? $t('ativado')
                                                    : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoG.preenchemanual">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('gera-valor') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoG.geravalor"
                                            :title="
                                                eventoG.geravalor ? $t('ativado') : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoG.geravalor">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label class="label-medium">{{ $t('formulario') }}</label>
                                        <div class="group-buttons">
                                            <b-button
                                                :type="
                                                    eventoG.permiteformulario ? 'is-primary' : ''
                                                "
                                                :outlined="!eventoG.permiteformulario"
                                                @click="changeCheckHabilita('G')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                :type="eventoG.obrigaformulario ? 'is-primary' : ''"
                                                :outlined="!eventoG.obrigaformulario"
                                                @click="changeCheckObriga('G')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label v-text="$t('ordem')" />
                                        <the-mask
                                            type="text"
                                            v-model="eventoG.ordem"
                                            :mask="['###']"
                                            v-bind:placeholder="$t('ordem-placeholder')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-flex-wrap mt-2" v-if="initend">
                    <div class="column is-6">
                        <div class="box">
                            <p v-text="$t('inicio')" class="mb-2" />
                            <div class="options">
                                <div class="columns is-flex-wrap">
                                    <div class="column is-6">
                                        <label>{{ $t('campo-obrigatorio') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoI.obriga"
                                            :title="
                                                eventoI.obriga ? $t('ativado') : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoI.obriga">{{ $t('ativado') }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('respeita-ordem') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoI.respeitaordem"
                                            :title="
                                                eventoI.respeitaordem
                                                    ? $t('ativado')
                                                    : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoI.respeitaordem">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('preenche-manual') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoI.preenchemanual"
                                            :title="
                                                eventoI.preenchemanual
                                                    ? $t('ativado')
                                                    : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoI.preenchemanual">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('gera-valor') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoI.geravalor"
                                            :title="
                                                eventoI.geravalor ? $t('ativado') : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoI.geravalor">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label class="label-medium">{{ $t('formulario') }}</label>
                                        <div class="group-buttons">
                                            <b-button
                                                :type="
                                                    eventoI.permiteformulario ? 'is-primary' : ''
                                                "
                                                :outlined="!eventoI.permiteformulario"
                                                @click="changeCheckHabilita('I')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                :type="eventoI.obrigaformulario ? 'is-primary' : ''"
                                                :outlined="!eventoI.obrigaformulario"
                                                @click="changeCheckObriga('I')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label v-text="$t('ordem')" />
                                        <the-mask
                                            type="text"
                                            v-model="eventoI.ordem"
                                            :mask="['###']"
                                            v-bind:placeholder="$t('ordem-placeholder')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="box">
                            <p v-text="$t('fim')" class="mb-2" />
                            <div class="options">
                                <div class="columns is-flex-wrap">
                                    <div class="column is-6">
                                        <label>{{ $t('campo-obrigatorio') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoF.obriga"
                                            :title="
                                                eventoF.obriga ? $t('ativado') : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoF.obriga">{{ $t('ativado') }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('respeita-ordem') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoF.respeitaordem"
                                            :title="
                                                eventoF.respeitaordem
                                                    ? $t('ativado')
                                                    : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoF.respeitaordem">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('preenche-manual') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoF.preenchemanual"
                                            :title="
                                                eventoF.preenchemanual
                                                    ? $t('ativado')
                                                    : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoF.preenchemanual">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label>{{ $t('gera-valor') }}</label
                                        ><br />
                                        <b-switch
                                            v-model="eventoF.geravalor"
                                            :title="
                                                eventoF.geravalor ? $t('ativado') : $t('desativado')
                                            "
                                        >
                                            <span v-if="eventoF.geravalor">{{
                                                $t('ativado')
                                            }}</span>
                                            <span v-else>{{ $t('desativado') }}</span>
                                        </b-switch>
                                    </div>
                                    <div class="column is-6">
                                        <label class="label-medium">{{ $t('formulario') }}</label>
                                        <div class="group-buttons">
                                            <b-button
                                                :type="
                                                    eventoF.permiteformulario ? 'is-primary' : ''
                                                "
                                                :outlined="!eventoF.permiteformulario"
                                                @click="changeCheckHabilita('F')"
                                            >
                                                <span>{{ $t('habilita') }}</span>
                                            </b-button>
                                            <b-button
                                                :type="eventoF.obrigaformulario ? 'is-primary' : ''"
                                                :outlined="!eventoF.obrigaformulario"
                                                @click="changeCheckObriga('F')"
                                            >
                                                <span>{{ $t('obriga') }}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label v-text="$t('ordem')" />
                                        <the-mask
                                            type="text"
                                            v-model="eventoF.ordem"
                                            :mask="['###']"
                                            v-bind:placeholder="$t('ordem-placeholder')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventoService from '@/services/promotor/EventoService';
import EventoValidation from '@/services/validations/EventoValidation';
import Message from '@/models/Message';
import { TheMask } from 'vue-the-mask';

export default {
    components: {
        TheMask,
    },
    data() {
        return {
            isSaving: false,
            eventoDados: {
                idtipoeventoerp: null,
                descricao: null,
            },
            title: '',
            msgs: [],
            tfs: [
                { label: 'Não', id: 0 },
                { label: 'Sim', id: 1 },
            ],
            tf: { label: 'Não', id: 0 },
            initend: false,
            isLoading: false,
            isUpdate: false,
            evento: {
                idevento: null,
                idtipoevento: null,
                tipo: 'G',
                ordem: null,
                obriga: false,
                respeitaordem: false,
                preenchemanual: false,
                geravalor: false,
                permiteformulario: false,
                obrigaformulario: false,
            },
            eventoG: {},
            eventoI: {},
            eventoF: {},
            first: true,
        };
    },
    created() {
        this.service = new EventoService(this.$http, this.$router);
        this.validation = new EventoValidation(this.msgs);

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'events');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'evento' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'evento' },
                });
            }
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            } else {
                this.first = false;
            }
            this.eventoG = Object.assign({}, this.evento);
        }
    },
    watch: {
        initend() {
            this.controlEvt();
        },
    },
    methods: {
        changeCheckHabilita(v) {
            if (v == 'G') {
                this.eventoG.permiteformulario = !this.eventoG.permiteformulario;
                if (this.eventoG.permiteformulario == false) this.eventoG.obrigaformulario = false;
            } else if (v == 'I') {
                this.eventoI.permiteformulario = !this.eventoI.permiteformulario;
                if (this.eventoI.permiteformulario == false) this.eventoI.obrigaformulario = false;
            } else if (v == 'F') {
                this.eventoF.permiteformulario = !this.eventoF.permiteformulario;
                if (this.eventoF.permiteformulario == false) this.eventoF.obrigaformulario = false;
            }
        },
        changeCheckObriga(v) {
            if (v == 'G') {
                this.eventoG.obrigaformulario = !this.eventoG.obrigaformulario;
                if (this.eventoG.obrigaformulario == true) this.eventoG.permiteformulario = true;
            } else if (v == 'I') {
                this.eventoI.obrigaformulario = !this.eventoI.obrigaformulario;
                if (this.eventoI.obrigaformulario == true) this.eventoI.permiteformulario = true;
            } else if (v == 'F') {
                this.eventoF.obrigaformulario = !this.eventoF.obrigaformulario;
                if (this.eventoF.obrigaformulario == true) this.eventoF.permiteformulario = true;
            }
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((body) => {
                    this.isLoading = false;
                    if (body.content) {
                        this.eventoDados = body.content;
                        this.title = this.eventoDados.descricao;
                        let evt = Object.assign(this.eventoDados.eventos);
                        if (evt && evt.length > 0) {
                            evt.forEach((ev) => {
                                ev.obriga = ev.obriga == 0 ? false : true;
                                ev.respeitaordem = ev.respeitaordem == 0 ? false : true;
                                ev.preenchemanual = ev.preenchemanual == 0 ? false : true;
                                ev.geravalor = ev.geravalor == 0 ? false : true;
                                ev.permiteformulario = ev.permiteformulario == 0 ? false : true;
                                ev.obrigaformulario = ev.obrigaformulario == 0 ? false : true;
                                if (ev.tipo == 'G') {
                                    this.eventoG = ev;
                                    this.eventoI = {};
                                    this.eventoF = {};
                                } else {
                                    this.initend = true;
                                    this.eventoG = {};
                                    if (ev.tipo == 'I') {
                                        this.eventoI = ev;
                                    } else if (ev.tipo == 'F') {
                                        this.eventoF = ev;
                                    }
                                }
                            });
                        }
                        this.tf = {
                            id: this.eventoDados.obrigaeventoantesformulario,
                            label: this.eventoDados.obrigaeventoantesformulario ? 'Sim' : 'Não',
                        };
                    } else {
                        this.$router.push({ name: 'new-event' });
                    }
                })
                .finally((_) => {
                    this.first = false;
                });
        },

        controlEvt() {
            if (this.initend == false && this.first == false) {
                this.eventoG = Object.assign({}, this.evento);
                if (this.eventoDados.id) this.eventoG.idevento = this.eventoDados.id;
                this.eventoI = {};
                this.eventoF = {};
            } else if (this.initend == true && this.first == false) {
                this.eventoG = {};
                this.eventoI = Object.assign({}, this.evento);
                if (this.eventoDados.id) this.eventoI.idevento = this.eventoDados.id;
                this.eventoI.tipo = 'I';
                this.eventoF = Object.assign({}, this.evento);
                if (this.eventoDados.id) this.eventoF.idevento = this.eventoDados.id;
                this.eventoF.tipo = 'F';
            }
        },
        updateObrigaEvento(tf) {
            if (tf && tf.id != null) {
                this.eventoDados.obrigaeventoantesformulario = tf.id;
                this.tf = tf;
            }
        },
        booleanToInt() {
            this.eventoDados.obrigaeventoantesformulario = this.eventoDados
                .obrigaeventoantesformulario
                ? 1
                : 0;
            this.eventoDados.eventos = [];
            if (this.initend == false) {
                this.eventoDados.eventos.push({
                    idevento: this.eventoG.idevento,
                    idtipoevento: this.eventoG.idtipoevento,
                    tipo: this.eventoG.tipo,
                    ordem: this.eventoG.ordem,
                    obriga: this.eventoG.obriga == false ? 0 : 1,
                    respeitaordem: this.eventoG.respeitaordem == false ? 0 : 1,
                    preenchemanual: this.eventoG.preenchemanual == false ? 0 : 1,
                    geravalor: this.eventoG.geravalor == false ? 0 : 1,
                    permiteformulario: this.eventoG.permiteformulario == false ? 0 : 1,
                    obrigaformulario: this.eventoG.obrigaformulario == false ? 0 : 1,
                });
            } else {
                this.eventoDados.eventos.push({
                    idevento: this.eventoI.idevento,
                    idtipoevento: this.eventoI.idtipoevento,
                    tipo: this.eventoI.tipo,
                    ordem: this.eventoI.ordem,
                    obriga: this.eventoI.obriga == false ? 0 : 1,
                    respeitaordem: this.eventoI.respeitaordem == false ? 0 : 1,
                    preenchemanual: this.eventoI.preenchemanual == false ? 0 : 1,
                    geravalor: this.eventoI.geravalor == false ? 0 : 1,
                    permiteformulario: this.eventoI.permiteformulario == false ? 0 : 1,
                    obrigaformulario: this.eventoI.obrigaformulario == false ? 0 : 1,
                });
                this.eventoDados.eventos.push({
                    idevento: this.eventoF.idevento,
                    idtipoevento: this.eventoF.idtipoevento,
                    tipo: this.eventoF.tipo,
                    ordem: this.eventoF.ordem,
                    obriga: this.eventoF.obriga == false ? 0 : 1,
                    respeitaordem: this.eventoF.respeitaordem == false ? 0 : 1,
                    preenchemanual: this.eventoF.preenchemanual == false ? 0 : 1,
                    geravalor: this.eventoF.geravalor == false ? 0 : 1,
                    permiteformulario: this.eventoF.permiteformulario == false ? 0 : 1,
                    obrigaformulario: this.eventoF.obrigaformulario == false ? 0 : 1,
                });
            }
        },
        salvar() {
            this.isSaving = true;
            if (this.validation.validate(this.eventoDados, this.$refs)) {
                this.booleanToInt();
                this.eventoDados.descricao = this.mapTosave(this.eventoDados.descricao);
                this.service
                    .save(this.eventoDados)
                    .then((body) => {
                        let msg = 'msg-event-salva';
                        if (this.eventoDados.id) {
                            msg = 'msg-event-edita';
                        }
                        this.eventoDados = body.content;
                        this.msgs.push(new Message('success', msg, true));
                        this.redirectToList();
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({ name: 'events' });
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    .obriga {
        height: 36px;
    }
    @media only screen and (min-width: 760px) {
        nav.breadcrumb {
            margin-right: 410px;
        }
    }
}
</style>
